import { Component, inject, input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { Utils } from '@services/utils.service';
import { ICustomerHistoryItem } from '@common-interfaces/organization-customer-views';
import { EmptyStateComponent } from '../../../../components/shared/empty-state/empty-state.component';

export interface CustomerHistoryRow extends ICustomerHistoryItem {
    venueName?: string;
}

const STATUS_SEVERITY: Record<string, 'success' | 'info' | 'danger' | 'warn' | 'secondary'> = {
    FINISHED: 'success',
    PLANNED: 'info',
    STARTED: 'info',
    CANCELED: 'danger',
    INITIALISED: 'warn'
};

@Component({
    selector: 'fb-customer-history',
    imports: [TableModule, TagModule, DatePipe, TranslatePipe, EmptyStateComponent],
    template: `
        <p-table [value]="items()" [paginator]="items().length > 10" [rows]="10" [rowHover]="true">
            <ng-template #header>
                <tr>
                    <th>{{ 'DATE' | translate }}</th>
                    @if (showVenue()) {
                        <th>{{ 'VENUE' | translate }}</th>
                    }
                    <th>{{ 'TYPE' | translate }}</th>
                    <th>{{ 'BOOKING_NUMBER' | translate }}</th>
                    <th class="text-right">{{ 'PARTICIPANTS' | translate }}</th>
                    <th class="text-right">{{ 'VALUE' | translate }}</th>
                    <th>{{ 'STATUS' | translate }}</th>
                </tr>
            </ng-template>
            <ng-template #body let-item>
                <tr>
                    <td class="whitespace-nowrap">{{ item.date | date: 'mediumDate' }}</td>
                    @if (showVenue()) {
                        <td>{{ item.venueName }}</td>
                    }
                    <td>{{ 'HISTORY_TYPE_' + item.type | translate }}</td>
                    <td class="text-text-muted">{{ item.bookingNumber ?? '–' }}</td>
                    <td class="text-right">{{ item.persons ?? '–' }}</td>
                    <td class="text-right whitespace-nowrap">{{ item.price ? utils.currencyFormat(item.price.withVat ?? 0, item.currency) : '–' }}</td>
                    <td>
                        @if (item.status) {
                            <p-tag [value]="'STATUS_' + item.status | translate" [severity]="severity(item.status)" />
                        }
                    </td>
                </tr>
            </ng-template>
            <ng-template #emptymessage>
                <tr>
                    <td [attr.colspan]="showVenue() ? 7 : 6">
                        <fb-empty-state icon="ph-calendar-blank" [title]="'NO_HISTORY' | translate" [text]="'NO_HISTORY_TEXT' | translate" />
                    </td>
                </tr>
            </ng-template>
        </p-table>
    `
})
export class CustomerHistoryComponent {
    utils = inject(Utils);
    items = input.required<CustomerHistoryRow[]>();
    showVenue = input(false);

    severity(status: string) {
        return STATUS_SEVERITY[status] ?? 'secondary';
    }
}
